import {Component, OnInit, TemplateRef} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {string} from '@amcharts/amcharts4/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TSFuntionService} from '../../services/ts-funtion.service';
import {DecimalPipe} from '@angular/common';
import {SWAlertService} from '../../services/swalert.service';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead/public_api';
import Swal from 'sweetalert2';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
import {Router} from '@angular/router';
import {slice} from '@amcharts/amcharts4/.internal/core/utils/Array';

@Component({
  selector: 'app-manual-updatefi-import',
  templateUrl: './manual-updatefi-import.component.html',
  styleUrls: ['./manual-updatefi-import.component.css']
})
export class ManualUpdatefiImportComponent implements OnInit {
  // Declare variable
  // Form controll
  sFIDocFrom = new FormGroup({
    sFIDocRowNum: new FormControl(''),
    sFIDocReqID: new FormControl(''),
    sFIDocReqCode: new FormControl(''),
    sFIDocItemNO: new FormControl(''),
    sFiDoc: new FormControl('', Validators.required),
    sFiDocCoCd: new FormControl(''),
    sFiDocYear: new FormControl('', Validators.required)
  });
  ClearingDocFrom = new FormGroup({
    clearingDocRowNum: new FormControl(''),
    clearingDocReqID: new FormControl(''),
    clearingReqCode: new FormControl(''),
    clearingItemNO: new FormControl(''),
    clearingDoc: new FormControl('', Validators.required),
    clearingDocCoCd: new FormControl(''),
    clearingDocYear: new FormControl('', Validators.required)
  });
  AdvClearingDocFrom = new FormGroup({
    AdvClearingDocRowNum: new FormControl(''),
    AdvClearingDocReqID: new FormControl(''),
    AdvClearingReqCode: new FormControl(''),
    AdvClearingItemNO: new FormControl(''),
    AdvClearingDoc: new FormControl('', Validators.required),
    AdvClearingCoCd: new FormControl(''),
    AdvClearingYear: new FormControl('', Validators.required)
  });
  ReceiveDocFrom = new FormGroup({
    ReceiveDocRowNum: new FormControl(''),
    ReceiveDocReqID: new FormControl(''),
    ReceiveReqCode: new FormControl(''),
    ReceiveItemNO: new FormControl(''),
    ReceiveDoc: new FormControl('', Validators.required),
    ReceiveCoCd: new FormControl(''),
    ReceiveYear: new FormControl('', Validators.required)
  });
  fileName = '';
  // This for modal
  modalRef: BsModalRef;
  // ReqNo.
  _sReqNo: any[] = [];
  IsReqNo = false;
  txtReqNo: string = null;
  sReqNo: any;
  // FI Doc no
  _sFIDoc: any[] = [];
  IsFIDoc = false;
  txtFIDoc: string = null;
  sFIDoc: any;
  // Company
  company: any[] = [];
  settings_com = {};
  CompanyData: any[] = [];
  // ReqType
  ReqType: any[] = [];
  settings_ReqType = {};
  txtReqType: any[] = [];

  // Table Display
  ColumnsData = [
    {
      ColumnName: 'Request No.',
      Value: 'sRequestCode',
      Section: 1,
      show: 'n',
      SortField: 'sRequestCode',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Request Type',
      Value: 'sReqType',
      Section: 1,
      show: 'n',
      SortField: 'sReqType',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Receipt No.',
      Value: 'sInvoiceNo',
      Section: 1,
      show: 'n',
      SortField: 'sInvoiceNo',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Amount',
      Value: 'nIncludeVAT',
      Section: 1,
      show: 'n',
      SortField: 'nIncludeVAT',
      Width: '2%',
      Align: 'center',
      Decimal: 'y',
    },
    {
      ColumnName: 'Cur.',
      Value: 'sCurrency',
      Section: 1,
      show: 'n',
      SortField: 'sCurrency',
      Width: '2%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Description',
      Value: 'Description',
      Section: 1,
      show: 'n',
      SortField: 'Description',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'FI Doc',
      Value: 'sFIDocNo',
      Section: 1,
      show: 'n',
      SortField: 'sFIDocNo',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'FI Doc Year',
      Value: 'nFIDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nFIDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Clearing Doc',
      Value: 'sClearingDoc',
      Section: 1,
      show: 'n',
      SortField: 'sClearingDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Clearing Doc Year',
      Value: 'nClearingDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nClearingDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Advance Clearing Doc',
      Value: 'sAdvClearingDoc',
      Section: 1,
      show: 'n',
      SortField: 'sAdvClearingDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Advance Clearing Doc Year',
      Value: 'nAdvClearingDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nAdvClearingDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Receive Doc',
      Value: 'sRecieveDoc',
      Section: 1,
      show: 'n',
      SortField: 'sRecieveDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Receive Doc Year',
      Value: 'nRecieveDocYear',
      Section: 1,
      show: 'y',
      SortField: 'nRecieveDocYear',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: '',
      Value: '',
      Section: 1,
      show: 'n',
      SortField: '',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
  ];
  IsCompanyFilter = false;
  IsLinkStatus = false;
  ColumnsSelected: any[] = [];
  IsHeaderSort = '';
  SortDirection = '';
  SortICO = 'fas fa-sort';
  IcoSort = 'fas fa-sort';
  IcoSortDesc = 'fas fa-sort-up';
  IcoSortAsc = 'fas fa-sort-down';
  _ArrDataBind = [];
  sDetailData = '';
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      {sValue: 10},
      {sValue: 20},
      {sValue: 50},
      {sValue: 100}
    ]
  };
  _ArrData: any;
  _FiReqType: any;
  _ClearingReqType: any;
  _AdvClearingReqType: any;
  _ReceiveReqType: any;
  isDisabledSaveFIDoc = true;
  isDisabledSaveClearingDoc = true;
  isDisabledSaveAdvClearingDoc = true;
  isDisabledSaveReceiveDoc = true;
  isDuplicate = false;
  fileDetail: File;
  ExcelData: any;
  isDisableImport = true;
  typeName: any;
  isDisabledSaveAll = true;
  _AllFI: any;
  constructor(private http: HttpClient,
              private System: TSFuntionService,
              private _decimalPipe: DecimalPipe,
              private modalService: BsModalService,
              private formBuilder: FormBuilder,
              private SW: SWAlertService,
              private router: Router
  ) {
  }

  async ngOnInit() {
    this.getReqNo();
    this.getReqType();
    this.getCompany();
    this.getFiNo();
    this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_ReqType = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    await this.getControlInput();

  }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    switch (index) {
      case 'txtReqNo':
        if (this.IsReqNo && this.txtReqNo) {
          this.sReqNo = null;
        } else {
          const sReqNo = this.txtReqNo.trim();
          const CHK = this._sReqNo.filter(f => f.sRequestCode === sReqNo);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtReqNo = '';
          }
        }
        break;
      case 'txtFIDoc':
        if (this.IsFIDoc && this.txtFIDoc) {
          this.sFIDoc = null;
        } else {
          const sFIDoc = this.txtFIDoc.trim();
          const CHK = this._sFIDoc.filter(f => f.sFIDoc === sFIDoc);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtFIDoc = '';
          }
        }
        break;
    }
  }

  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case 'txtReqNo':
        this.sReqNo = event.item.value;
        break;
      case 'txtFIDoc':
        this.sFIDoc = event.item.value;
        break;
    }
  }

  getCompany() {
    this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetCompany').subscribe(res => {
      if (res) {
        this.company = res;
      }
    });
  }

  getReqType() {
    this.http.get<any>(this.System.SiteName + 'api/Search/Getpaytype').toPromise().then(res => {
      if (res) {
        this.ReqType = res;
      }
    });
  }

  getReqNo() {
    this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetReqNo').toPromise().then(res => {
      this.sReqNo = res;
      this._sReqNo = res;
    });
  }

  getFiNo() {
    this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetFINo').toPromise().then(res => {
      this.sFIDoc = res;
      this._sFIDoc = res;
    });
  }

  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrDataBind = _.orderBy(this._ArrDataBind, [SortField], [this.SortDirection]);
    }
  }

  _RowResult(decimal, value) {
    return (decimal === 'y' && value !== null) ? this._ConvertToDecimal(value) : value;
  }

  _ConvertToDecimal(sVal) {
    const NoComma = (sVal + '').replace(/,/g, ''); // ตัด Comma ออก
    const Data = this._decimalPipe.transform(NoComma, '1.2-2');
    return Data;
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;
    const nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize);
    const nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    const nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    const nStartItemPage = nStartIndex_Take + 1;
    const nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = 'Showing ' + nStartItemPage + ' to ' + nLastItemPage + ' of ' + this._ArrData.length + ' Rows';
    this.System.UnBlockUI();
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  ClearData() {
    window.location.reload();
  }

  checkToHideReqNo(index) {
    let result = this._ArrDataBind[index]['sRequestCode'];
    if (index > 0) {
      const lastP = index - 1;
      if (this._ArrDataBind[lastP]['sRequestCode'] === this._ArrDataBind[index]['sRequestCode']) {
        result = '';
      }
    }
    return result;
  }

  checkToHideField(field, index) {
    const ReqTypeIndex = this.explodeNReqType()[0].indexOf(this._ArrDataBind[index]['sReqType']);
    const sReqTypeNo = this.explodeNReqType()[1][ReqTypeIndex];
    if (field === 'sFiDoc' && this._FiReqType) {
      const result = this._FiReqType.indexOf(sReqTypeNo);
      if (result > -1) {
        return true;
      }
    }
    if (field === 'sClearingDoc' && this._ClearingReqType) {
      const result = this._ClearingReqType.indexOf(sReqTypeNo);
      if (result > -1) {
        return true;
      }
    }
    if (field === 'sAdvClearingDoc' && this._AdvClearingReqType) {
      const result = this._AdvClearingReqType.indexOf(sReqTypeNo);
      if (result > -1) {
        return true;
      }
    }
    if (field === 'sRecieveDoc' && this._ReceiveReqType) {
      const result = this._ReceiveReqType.indexOf(sReqTypeNo);
      if (result > -1) {
        return true;
      }
    }
    return false;
  }

  explodeNReqType() {
    const result = [];
    const name = [];
    const number = [];

    for (let x = 0; x < this.typeName.length; x++) {
      name.push(this.typeName[x]['sReqType']);
      // tslint:disable-next-line:radix
      number.push(parseInt(this.typeName[x]['nReqType']));
    }
    result.push(name);
    result.push(number);
    return result;
  }

  async getControlInput() {
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/GetNameReqType').toPromise().then(res => {
      if (res) {
        this.typeName = res;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/FiReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._FiReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/ClearingReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._ClearingReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/AdvClearingReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._AdvClearingReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/ReceiveReqType').toPromise().then(res => {
      if (res) {
        const data = res[0]['sValueText'].split(',');
        const result = [];
        for (let x = 0; x < data.length; x++) {
          // tslint:disable-next-line:radix
          result.push(parseInt(data[x]));
        }
        this._ReceiveReqType = result;
      }
    });
    await this.http.get<any>(this.System.SiteName + 'api/ManualUpdateFi/getAllFI').toPromise().then(res => {
      if (res) {
        this._AllFI = res;
      }
    });
  }

  checkYearValue(value) {
    const d = new Date();
    let year = d.getFullYear();
    if (value != "" && value != undefined) {
      year = value
    }
    return year
  }

  OpensFiDoc(templateFiDoc: TemplateRef<any>, numRow) {
    this.sFIDocFrom.get('sFIDocRowNum').setValue(this._ArrDataBind[numRow]['rowNumber']);
    this.sFIDocFrom.get('sFIDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.sFIDocFrom.get('sFIDocReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.sFIDocFrom.get('sFIDocItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.sFIDocFrom.controls.sFiDoc.setValue(this._ArrDataBind[numRow]['sFiDoc']);
    this.sFIDocFrom.controls.sFiDocCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.sFIDocFrom.controls.sFiDocYear.setValue(this._ArrDataBind[numRow]['nFIDocYear']);
    this.sFIDocFrom.controls.sFiDocYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nFIDocYear']));
    this.modalRef = this.modalService.show(
      templateFiDoc,
      Object.assign({}, {class: 'gray modal-xl'})
    );
  }

  OpensClearingDoc(templateClearingDoc: TemplateRef<any>, numRow) {
    this.ClearingDocFrom.get('clearingDocRowNum').setValue(this._ArrDataBind[numRow]['rowNumber']);
    this.ClearingDocFrom.get('clearingDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.ClearingDocFrom.get('clearingReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.ClearingDocFrom.get('clearingItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.ClearingDocFrom.controls.clearingDoc.setValue(this._ArrDataBind[numRow]['sClearingDoc']);
    this.ClearingDocFrom.controls.clearingDocCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.ClearingDocFrom.controls.clearingDocYear.setValue(this._ArrDataBind[numRow]['nClearingDocYear']);
    this.ClearingDocFrom.controls.clearingDocYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nClearingDocYear']));
    this.modalRef = this.modalService.show(
      templateClearingDoc,
      Object.assign({}, {class: 'gray modal-xl'})
    );
  }

  OpensAdvClearingDoc(templateAdvClearingDoc: TemplateRef<any>, numRow) {
    this.AdvClearingDocFrom.get('AdvClearingDocRowNum').setValue(this._ArrDataBind[numRow]['rowNumber']);
    this.AdvClearingDocFrom.get('AdvClearingDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.AdvClearingDocFrom.get('AdvClearingReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.AdvClearingDocFrom.get('AdvClearingItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.AdvClearingDocFrom.controls.AdvClearingDoc.setValue(this._ArrDataBind[numRow]['sAdvClearingDoc']);
    this.AdvClearingDocFrom.controls.AdvClearingCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.AdvClearingDocFrom.controls.AdvClearingYear.setValue(this._ArrDataBind[numRow]['nAdvClearingDocYear']);
    this.AdvClearingDocFrom.controls.AdvClearingYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nAdvClearingDocYear']));
    this.modalRef = this.modalService.show(
      templateAdvClearingDoc,
      Object.assign({}, {class: 'gray modal-xl'})
    );
  }

  OpensReceiveDoc(templateReceiveDoc: TemplateRef<any>, numRow) {
    this.ReceiveDocFrom.get('ReceiveDocRowNum').setValue(this._ArrDataBind[numRow]['rowNumber']);
    this.ReceiveDocFrom.get('ReceiveDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.ReceiveDocFrom.get('ReceiveReqCode').setValue(this._ArrDataBind[numRow]['sRequestCode']);
    this.ReceiveDocFrom.get('ReceiveItemNO').setValue(this._ArrDataBind[numRow]['nItemNo']);
    this.ReceiveDocFrom.controls.ReceiveDoc.setValue(this._ArrDataBind[numRow]['sRecieveDoc']);
    this.ReceiveDocFrom.controls.ReceiveCoCd.setValue(this._ArrDataBind[numRow]['sCompCode']);
    //this.ReceiveDocFrom.controls.ReceiveYear.setValue(this._ArrDataBind[numRow]['nRecieveDocYear']);
    this.ReceiveDocFrom.controls.ReceiveYear.setValue(this.checkYearValue(this._ArrDataBind[numRow]['nRecieveDocYear']));
    this.modalRef = this.modalService.show(
      templateReceiveDoc,
      Object.assign({}, {class: 'gray modal-xl'})
    );
  }

  isFieldValid(form, _Field: string) {
    if (form === 'sFIDocFrom') {
      return !this.sFIDocFrom.get(_Field).valid && this.sFIDocFrom.get(_Field).touched;
    }
    if (form === 'ClearingDocFrom') {
      return !this.ClearingDocFrom.get(_Field).valid && this.ClearingDocFrom.get(_Field).touched;
    }
    if (form === 'AdvClearingDocFrom') {
      return !this.AdvClearingDocFrom.get(_Field).valid && this.AdvClearingDocFrom.get(_Field).touched;
    }
    if (form === 'ReceiveDocFrom') {
      return !this.ReceiveDocFrom.get(_Field).valid && this.ReceiveDocFrom.get(_Field).touched;
    }
  }

  displayFieldCss(form, _Field: string) {
    return {
      'has-error': this.isFieldValid(form, _Field),
      'has-feedback': this.isFieldValid(form, _Field)
    };
  }

  checkSaveMinimum(form, _Field: string) {
    if (form === 'sFIDocFrom') {
      if (this.sFIDocFrom.get(_Field).value) {
        if (this.sFIDocFrom.get(_Field).value.toString().length === 10) {
          this.isDisabledSaveFIDoc = false;
        } else {
          this.isDisabledSaveFIDoc = true;
        }
      } else {
        this.isDisabledSaveFIDoc = true;
      }
    }
    if (form === 'ClearingDocFrom') {
      if (this.ClearingDocFrom.get(_Field).value) {
        if (this.ClearingDocFrom.get(_Field).value.toString().length === 10) {
          this.isDisabledSaveClearingDoc = false;
        } else {
          this.isDisabledSaveClearingDoc = true;
        }
      } else {
        this.isDisabledSaveClearingDoc = true;
      }
    }
    if (form === 'AdvClearingDocFrom') {
      if (this.AdvClearingDocFrom.get(_Field).value) {
        if (this.AdvClearingDocFrom.get(_Field).value.toString().length === 10) {
          this.isDisabledSaveAdvClearingDoc = false;
        } else {
          this.isDisabledSaveAdvClearingDoc = true;
        }
      } else {
        this.isDisabledSaveAdvClearingDoc = true;
      }
    }
    if (form === 'ReceiveDocFrom') {
      if (this.ReceiveDocFrom.get(_Field).value) {
        if (this.ReceiveDocFrom.get(_Field).value.toString().length === 10) {
          this.isDisabledSaveReceiveDoc = false;
        } else {
          this.isDisabledSaveReceiveDoc = true;
        }
      } else {
        this.isDisabledSaveReceiveDoc = true;
      }
    }
    return '';
  }

  async importFile(event) {
    const target: DataTransfer = <DataTransfer>(event.target);
    this.fileName = target.files[0].name;
    this.fileDetail = target.files[0];
    const reader: FileReader = new FileReader();
    const result = [];
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const workbook = XLSX.read(bstr, {type: 'binary'});
      const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      this.ExcelData = data;
    };
    reader.readAsBinaryString(this.fileDetail);
  }

  async readFile() {
    this.System.BlockUI();
    if (this.ExcelData.length > 0 && this.ExcelData[0]['Request ID.']) {
      const result = [];
      for (let x = 0; x < this.ExcelData.length; x++) {
        const items = {
          'rowNumber': null,
          'sRequestID': '',
          'sRequestCode': '',
          'sReqType': '',
          'sCompCode': '',
          'nItemNo': null,
          'sInvoiceNo': '',
          'nIncludeVAT': null,
          'sCurrency': '',
          'sInvoiceDesc': '',
          'sFiDoc': null,
          'nFIDocYear': null,
          'sClearingDoc': null,
          'nClearingDocYear': null,
          'sAdvClearingDoc': null,
          'nAdvClearingDocYear': null,
          'sRecieveDoc': null,
          'nRecieveDocYear': null,
          'show': false
        };
        items.rowNumber = x;
        items.sRequestID = this.ExcelData[x]['Request ID.'];
        items.sRequestCode = this.ExcelData[x]['Request No.'];
        items.sReqType = this.ExcelData[x]['Request Type'];
        items.sCompCode = this.ExcelData[x]['COCD'];
        items.nItemNo = this.ExcelData[x]['Item No.'];
        items.sInvoiceNo = this.ExcelData[x]['Receipt No.'];
        items.nIncludeVAT = this.ExcelData[x]['Amount'];
        items.sCurrency = this.ExcelData[x]['Cur.'];
        items.sInvoiceDesc = this.ExcelData[x]['Description'];
        items.sFiDoc = this.ExcelData[x]['FI Doc'];
        items.nFIDocYear = this.ExcelData[x]['FI Doc Year'];
        items.sClearingDoc = this.ExcelData[x]['Clearing Doc'];
        items.nClearingDocYear = this.ExcelData[x]['Clearing Doc Year'];
        items.sAdvClearingDoc = this.ExcelData[x]['Advance Clearing Doc'];
        items.nAdvClearingDocYear = this.ExcelData[x]['Advance Clearing Doc Year'];
        items.sRecieveDoc = this.ExcelData[x]['Receive Doc'];
        items.nRecieveDocYear = this.ExcelData[x]['Receive Doc Year'];
        result.push(items);
      }
      this._ArrData = result;
      this.isDisabledSaveAll = false;
    } else {
      this._ArrData = [];
      this.isDisabledSaveAll = true;
      this.SW.SwAlert.Warning(this.SW.BoxMsg.Title_Warning, 'Please check the uploaded file. invalid format', function () {
        window.location.reload();
      });
    }
    this.BindDataTable();
  }

  checkHaveFileUpload() {
    if (this.ExcelData !== undefined) {
      this.isDisableImport = false;
    } else {
      this.isDisableImport = true;
    }
    return '';
  }

  deleteRow(index) {
    const This = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, 'Do you want to remove data?', function () {
      This._ArrData.splice(index, 1);
      This.BindDataTable();
    }, function () {
      Swal.close();
    });
  }

  checkIsNumber(value) {
    return typeof value === 'number';
  }

  async saveDoc(form) {
    let isValid = true;
    const This = this;
    const toSave = {
      formN: form,
      reqID: '',
      reqCode: '',
      itemNo: '',
      comCode: '',
      docNo: '',
      year: null
    };
    if (form === 'sFIDocFrom') {
      // tslint:disable-next-line:radix
      if (this.sFIDocFrom.controls.sFiDocYear.value !== null && Number.isInteger(parseInt(this.sFIDocFrom.controls.sFiDocYear.value))) {
        toSave.reqID = this.sFIDocFrom.controls.sFIDocReqID.value.toString();
        toSave.reqCode = this.sFIDocFrom.controls.sFIDocReqCode.value;
        toSave.itemNo = this.sFIDocFrom.controls.sFIDocItemNO.value;
        toSave.docNo = this.sFIDocFrom.controls.sFiDoc.value;
        toSave.comCode = this.sFIDocFrom.controls.sFiDocCoCd.value.toString();
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.sFIDocFrom.controls.sFiDocYear.value);
      } else {
        isValid = false;
        this.sFIDocFrom.get('sFiDocYear').markAsTouched({onlySelf: true});
      }
    }
    if (form === 'ClearingDocFrom') {
      if (
        this.ClearingDocFrom.controls.clearingDocYear.value !== null
        // tslint:disable-next-line:radix
        && Number.isInteger(parseInt(this.ClearingDocFrom.controls.clearingDocYear.value))
      ) {
        toSave.reqID = this.ClearingDocFrom.controls.clearingDocReqID.value.toString();
        toSave.reqCode = this.ClearingDocFrom.controls.clearingReqCode.value;
        toSave.itemNo = this.ClearingDocFrom.controls.clearingItemNO.value;
        toSave.docNo = this.ClearingDocFrom.controls.clearingDoc.value;
        toSave.comCode = this.ClearingDocFrom.controls.clearingDocCoCd.value.toString();
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.ClearingDocFrom.controls.clearingDocYear.value);
      } else {
        isValid = false;
        this.ClearingDocFrom.get('clearingDocYear').markAsTouched({onlySelf: true});
      }
    }
    if (form === 'AdvClearingDocFrom') {
      if (
        this.AdvClearingDocFrom.controls.AdvClearingYear.value !== null
        // tslint:disable-next-line:radix
        && Number.isInteger(parseInt(this.AdvClearingDocFrom.controls.AdvClearingYear.value))
      ) {
        toSave.reqID = this.AdvClearingDocFrom.controls.AdvClearingDocReqID.value.toString();
        toSave.reqCode = this.AdvClearingDocFrom.controls.AdvClearingReqCode.value;
        toSave.itemNo = this.AdvClearingDocFrom.controls.AdvClearingItemNO.value;
        toSave.docNo = this.AdvClearingDocFrom.controls.AdvClearingDoc.value;
        toSave.comCode = this.AdvClearingDocFrom.controls.AdvClearingCoCd.value.toString();
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.AdvClearingDocFrom.controls.AdvClearingYear.value);
      } else {
        isValid = false;
        this.AdvClearingDocFrom.get('AdvClearingYear').markAsTouched({onlySelf: true});
      }
    }
    if (form === 'ReceiveDocFrom') {
      if (
        this.ReceiveDocFrom.controls.ReceiveYear.value !== null
        // tslint:disable-next-line:radix
        && Number.isInteger(parseInt(this.ReceiveDocFrom.controls.ReceiveYear.value))
      ) {
        toSave.reqID = this.ReceiveDocFrom.controls.ReceiveDocReqID.value.toString();
        toSave.reqCode = this.ReceiveDocFrom.controls.ReceiveReqCode.value;
        toSave.itemNo = this.ReceiveDocFrom.controls.ReceiveItemNO.value;
        toSave.docNo = this.ReceiveDocFrom.controls.ReceiveDoc.value;
        toSave.comCode = this.ReceiveDocFrom.controls.ReceiveCoCd.value.toString();
        // tslint:disable-next-line:radix
        toSave.year = parseInt(this.ReceiveDocFrom.controls.ReceiveYear.value);
      } else {
        isValid = false;
        this.ReceiveDocFrom.get('ReceiveYear').markAsTouched({onlySelf: true});
      }
    }
    if (isValid) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      const ITEM = JSON.stringify(toSave);
      await this.http.post(this.System.SiteName + 'api/ManualUpdateFi/CheckDuplicate', ITEM,
        // tslint:disable-next-line:no-shadowed-variable
        {headers, responseType: 'json'}).toPromise().then((data: Response) => {
        const item = Object.values(data);
        if (item.length > 0) {
          if (item[0]['Found'] > 0) {
            this.isDuplicate = true;
          } else {
            let checkOnfile = 0;
            if (form === 'sFIDocFrom') {
              checkOnfile = this._ArrData.filter(f => f.sFiDoc && f.nFIDocYear
                // tslint:disable-next-line:radix
                && f.sFiDoc.toString() === toSave.docNo && parseInt(f.nFIDocYear) === toSave.year).length;
            }
            if (form === 'ClearingDocFrom') {
              checkOnfile = this._ArrData.filter(f => f.sClearingDoc && f.nClearingDocYear
                // tslint:disable-next-line:radix
                && f.sClearingDoc.toString() === toSave.docNo && parseInt(f.nClearingDocYear) === toSave.year).length;
            }
            if (form === 'AdvClearingDocFrom') {
              checkOnfile = this._ArrData.filter(f => f.sAdvClearingDoc && f.nAdvClearingDocYear
                // tslint:disable-next-line:radix
                && f.sAdvClearingDoc.toString() === toSave.docNo && parseInt(f.nAdvClearingDocYear) === toSave.year).length;
            }
            if (form === 'ReceiveDocFrom') {
              checkOnfile = this._ArrData.filter(f => f.sRecieveDoc && f.nRecieveDocYear
                // tslint:disable-next-line:radix
                && f.sRecieveDoc.toString() === toSave.docNo && parseInt(f.nRecieveDocYear) === toSave.year).length;
            }

            this.isDuplicate = checkOnfile > 0;
          }
        }
      });
      if (this.isDuplicate === false) {
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, function () {
          if (form === 'sFIDocFrom') {
            This._ArrData[This.sFIDocFrom.controls.sFIDocRowNum.value]['sFiDoc'] = This.sFIDocFrom.controls.sFiDoc.value;
            This._ArrData[This.sFIDocFrom.controls.sFIDocRowNum.value]['nFIDocYear'] = This.sFIDocFrom.controls.sFiDocYear.value;
            This.BindDataTable();
            This.sFIDocFrom.reset();
          }
          if (form === 'ClearingDocFrom') {
            This._ArrData[This.ClearingDocFrom.controls.clearingDocRowNum.value]
              ['sClearingDoc'] = This.ClearingDocFrom.controls.clearingDoc.value;
            This._ArrData[This.ClearingDocFrom.controls.clearingDocRowNum.value]
              ['nClearingDocYear'] = This.ClearingDocFrom.controls.clearingDocYear.value;
            This.BindDataTable();
            This.ClearingDocFrom.reset();
          }
          if (form === 'AdvClearingDocFrom') {
            This._ArrData[This.AdvClearingDocFrom.controls.AdvClearingDocRowNum.value]
              ['sAdvClearingDoc'] = This.AdvClearingDocFrom.controls.AdvClearingDoc.value;
            This._ArrData[This.AdvClearingDocFrom.controls.AdvClearingDocRowNum.value]
              ['nAdvClearingDocYear'] = This.AdvClearingDocFrom.controls.AdvClearingYear.value;
            This.BindDataTable();
            This.AdvClearingDocFrom.reset();
          }
          if (form === 'ReceiveDocFrom') {
            This._ArrData[This.ReceiveDocFrom.controls.ReceiveDocRowNum.value]
              ['sRecieveDoc'] = This.ReceiveDocFrom.controls.ReceiveDoc.value;
            This._ArrData[This.ReceiveDocFrom.controls.ReceiveDocRowNum.value]
              ['nRecieveDocYear'] = This.ReceiveDocFrom.controls.ReceiveYear.value;
            This.BindDataTable();
            This.ReceiveDocFrom.reset();
          }
          This.modalRef.hide();
        }, function () {
          Swal.close();
        });
      }
    }
  }

  redirect() {
    const This = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, 'If you leave this page Unsaved data will be lost.', function () {
      This.router.navigate(['/manual-updatefi']);
    }, function () {
      Swal.close();
    });
  }

  showData(value): boolean {
    return value;
  }

 async saveALlTable(type) {
    const This = this;
    const item = This._ArrData;
    let validate = true;
    for (let x = 0; x < item.length; x++) {
      const checkingType = {
        sFiDocR: 'y',
        clearingDocR: 'y',
        AdvClearingDocR: 'y',
        ReceiveDocR: 'y',
      };
      const resultCheck = {
        sFiDocR: true,
        clearingDocR: true,
        AdvClearingDocR: true,
        ReceiveDocR: true,
      };
      const ReqTypeIndex = This.explodeNReqType()[0].indexOf(item[x]['sReqType']);
      const sReqTypeNo = This.explodeNReqType()[1][ReqTypeIndex];
      const sFiDocCheck = This._FiReqType.indexOf(sReqTypeNo);
      if (sFiDocCheck === -1) {
        checkingType.sFiDocR = 'n';
      }
      const sClearingDocCheck = This._ClearingReqType.indexOf(sReqTypeNo);
      if (sClearingDocCheck === -1) {
        checkingType.clearingDocR = 'n';
      }
      const sAdvClearingDocCheck = This._AdvClearingReqType.indexOf(sReqTypeNo);
      if (sAdvClearingDocCheck === -1) {
        checkingType.AdvClearingDocR = 'n';
      }
      const sRecieveDocCheck = This._ReceiveReqType.indexOf(sReqTypeNo);
      if (sRecieveDocCheck === -1) {
        checkingType.ReceiveDocR = 'n';
      }
      if (checkingType.sFiDocR === 'y') {
        if (item[x]['sFiDoc'] !== undefined) {
          const payload = {
            formN: 'sFIDocFrom',
            reqID : item[x]['sRequestID'],
            reqCode : item[x]['sRequestCode'],
            itemNo : item[x]['nItemNo'],
            docNo : item[x]['sFiDoc'].toString(),
            comCode : item[x]['sCompCode'].toString(),
            year : item[x]['nFIDocYear'],
          };
          if (item[x]['sFiDoc'].toString().length !== 10
            || this._ArrData.filter(f => f.sFiDoc === item[x]['sFiDoc'] && f.nFIDocYear === item[x]['nFIDocYear']).length > 1
            || this.checkDupFromAll(payload) === true
          ) {
            resultCheck.sFiDocR = false;
          }
        } else {
          resultCheck.sFiDocR = false;
        }
      }
      if (checkingType.clearingDocR === 'y') {
        if (item[x]['sClearingDoc'] !== undefined) {
          const payload = {
            formN: 'ClearingDocFrom',
            reqID : item[x]['sRequestID'],
            reqCode : item[x]['sRequestCode'],
            itemNo : item[x]['nItemNo'],
            docNo : item[x]['sClearingDoc'].toString(),
            comCode : item[x]['sCompCode'].toString(),
            year : item[x]['nClearingDocYear'],
          };
          if (item[x]['sClearingDoc'].toString().length !== 10
            || this._ArrData.filter(f => f.sClearingDoc === item[x]['sClearingDoc']
              && f.nClearingDocYear === item[x]['nClearingDocYear']).length > 1
            || this.checkDupFromAll(payload) === true
          ) {
            resultCheck.clearingDocR = false;
          }
        } else {
          resultCheck.clearingDocR = false;
        }
      }
      if (checkingType.AdvClearingDocR === 'y') {
        if (item[x]['sAdvClearingDoc'] !== undefined) {
          const payload = {
            formN: 'AdvClearingDocFrom',
            reqID : item[x]['sRequestID'],
            reqCode : item[x]['sRequestCode'],
            itemNo : item[x]['nItemNo'],
            docNo : item[x]['sAdvClearingDoc'].toString(),
            comCode : item[x]['sCompCode'].toString(),
            year : item[x]['nAdvClearingDocYear'],
          };
          if (item[x]['sAdvClearingDoc'].toString().length !== 10
            || this._ArrData.filter(f => f.sAdvClearingDoc === item[x]['sAdvClearingDoc'] && f.nAdvClearingDocYear === item[x]['nAdvClearingDocYear']).length > 1
            || this.checkDupFromAll(payload) === true
          ) {
            resultCheck.AdvClearingDocR = false;
          }
        } else {
          resultCheck.AdvClearingDocR = false;
        }
      }
      if (checkingType.ReceiveDocR === 'y') {
        if (item[x]['sRecieveDoc'] !== undefined) {
          const payload = {
            formN: 'ReceiveDocFrom',
            reqID : item[x]['sRequestID'],
            reqCode : item[x]['sRequestCode'],
            itemNo : item[x]['nItemNo'],
            docNo : item[x]['sRecieveDoc'].toString(),
            comCode : item[x]['sCompCode'].toString(),
            year : item[x]['nRecieveDocYear'],
          };
          if (item[x]['sRecieveDoc'].toString().length !== 10
            || this._ArrData.filter(f => f.sRecieveDoc === item[x]['sRecieveDoc']
              && f.nRecieveDocYear === item[x]['nRecieveDocYear']).length > 1
            || this.checkDupFromAll(payload) === true
          ) {
            resultCheck.ReceiveDocR = false;
          }
        } else {
          resultCheck.ReceiveDocR = false;
        }
      }
      const resultInsertCheck = Object.entries(resultCheck).filter(([key, value]) => value === true);
      item[x]['show'] = resultInsertCheck.length !== 4;
    }
    const falseResult = item.filter(val => val.show === true).length;
    if (falseResult > 0) {
      validate = false;
    }
    This._ArrData = item;
    This.BindDataTable();
    const saveDataProcess = function () {
      const ManualFiImportBody = [];
      for (let x = 0; x < This._ArrData.length; x++) {
        const itemToSave = {
          sRequestID: '',
          sRequestCode: '',
          sReqType: '',
          sCompCode: '',
          nItemNo: null,
          sFIDoc: '',
          nFIDocYear: null,
          sClearingDoc: '',
          nClearingDocYear: null,
          sAdvClearingDoc: '',
          nAdvClearingDocYear: null,
          sRecieveDoc: '',
          nRecieveDocYear: null
        };
        itemToSave.sRequestID = This._ArrData[x]['sRequestID'].toString();
        itemToSave.sRequestCode = This._ArrData[x]['sRequestCode'];
        itemToSave.sReqType = This._ArrData[x]['sReqType'];
        itemToSave.sCompCode = This._ArrData[x]['sCompCode'].toString();
        itemToSave.nItemNo = This._ArrData[x]['nItemNo'];
        itemToSave.sFIDoc = This._ArrData[x]['sFiDoc'] !== undefined ? This._ArrData[x]['sFiDoc'].toString() : '';
        // tslint:disable-next-line:radix
        itemToSave.nFIDocYear = This._ArrData[x]['nFIDocYear'] !== undefined ? parseInt(This._ArrData[x]['nFIDocYear']) : null;
        itemToSave.sClearingDoc = This._ArrData[x]['sClearingDoc'] !== undefined ? This._ArrData[x]['sClearingDoc'].toString() : '';

        itemToSave.nClearingDocYear = This._ArrData[x]['nClearingDocYear'] !== undefined ?
          // tslint:disable-next-line:radix max-line-length
          parseInt(This._ArrData[x]['nClearingDocYear']) : null;
        // tslint:disable-next-line:max-line-length
        itemToSave.sAdvClearingDoc = This._ArrData[x]['sAdvClearingDoc'] !== undefined ? This._ArrData[x]['sAdvClearingDoc'].toString() : '';
        itemToSave.nAdvClearingDocYear = This._ArrData[x]['nAdvClearingDocYear'] !== undefined ?
          // tslint:disable-next-line:radix
          parseInt(This._ArrData[x]['nAdvClearingDocYear']) : null;
        itemToSave.sRecieveDoc = This._ArrData[x]['sRecieveDoc'] !== undefined ? This._ArrData[x]['sRecieveDoc'].toString() : '';

        itemToSave.nRecieveDocYear = This._ArrData[x]['nRecieveDocYear'] !== undefined ?
          // tslint:disable-next-line:radix
          parseInt(This._ArrData[x]['nRecieveDocYear']) : null;
        ManualFiImportBody.push(itemToSave);
      }

      const mergeData = {
        ManualFiImportBody,
        nType: type
      };
      const prepareToRequest = [];
      prepareToRequest.push(mergeData);
      const saveAllTableData = JSON.stringify(prepareToRequest);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      This.http.post(This.System.SiteName + 'api/ManualUpdateFi/saveAllTableData', saveAllTableData, {
        headers,
        responseType: 'text',
      }).subscribe(result => {
        This.System.UnBlockUI();
        if (result === 'Success') {
          This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, 'Data is already saved.', function () {
            This.ClearData();
          });
        }
      });
    };
    if (validate) {
      if (type === 0) {
        this.SW.SwAlert.Confirm0(this.SW.BoxMsg.Title_Confirm, 'Do you want to import data?', saveDataProcess, function () {
        });
      } else {
        this.SW.SwAlert.Confirm1(this.SW.BoxMsg.Title_Confirm, 'Do you want to import data?', saveDataProcess, function () {
        });
      }
    } else {
      this.SW.SwAlert.Error('Error, Checking Alert', 'Please check, some items are incorrect.', undefined);
    }

  }

  checkDupFromAll(dataToCheck) {
    let result = false;
    let resultChecking = [];
    if (this._AllFI) {
      if (dataToCheck['formN'] === 'sFIDocFrom') {
        resultChecking = this._AllFI.filter(f => f.sCompCode === dataToCheck.comCode
            && f.sFIDoc === dataToCheck.docNo
            && f.nFIDocYear === dataToCheck.year
        );
      }
      if (dataToCheck['formN'] === 'ClearingDocFrom') {
        resultChecking = this._AllFI.filter(f => f.sCompCode === dataToCheck.comCode
          && f.sClearingDoc === dataToCheck.docNo
          && f.nClearingDocYear === dataToCheck.year
        );
      }
      if (dataToCheck['formN'] === 'AdvClearingDocFrom') {
        resultChecking = this._AllFI.filter(f => f.sCompCode === dataToCheck.comCode
          && f.sAdvClearingDoc === dataToCheck.docNo
          && f.nAdvClearingDocYear === dataToCheck.year
        );
      }
      if (dataToCheck['formN'] === 'ReceiveDocFrom') {
        resultChecking = this._AllFI.filter(f => f.sCompCode === dataToCheck.comCode
          && f.sRecieveDoc === dataToCheck.docNo
          && f.nRecieveDocYear === dataToCheck.year
        );
      }
      if (resultChecking.length > 0) {
        result = true;
      }
    }

    return result;
  }



  clearDisplayError() {
    this.sFIDocFrom.reset();
    this.ClearingDocFrom.reset();
    this.AdvClearingDocFrom.reset();
    this.ReceiveDocFrom.reset();
    this.isDuplicate = false;
    this.modalRef.hide();
  }

}
